var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.461,
    height: 80,
    viewBox: "0 0 76.461 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alarm",
    transform: "translate(-11.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12805",
    transform: "translate(36.28 21.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33529",
    fill: "#ffce99",
    d: "M171.042 186.63v-32.937a13.275 13.275 0 0 1 26.549 0v32.937z",
    opacity: 0.504,
    transform: "translate(-171.042 -140.485)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12806",
    transform: "translate(11.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33530",
    d: "M92.45 130.154h-4.792v-8.779a1.563 1.563 0 0 0-1.562-1.562h-3.487V88.5a25.381 25.381 0 0 0-25.352-25.355h-.119A25.381 25.381 0 0 0 31.785 88.5v31.315H28.3a1.563 1.563 0 0 0-1.562 1.563v8.779h-4.794a1.563 1.563 0 1 0 0 3.125H92.45a1.563 1.563 0 0 0 0-3.125zM34.91 88.5a22.252 22.252 0 0 1 22.228-22.23h.119A22.253 22.253 0 0 1 79.484 88.5v31.315H58.76v-14.658a6.287 6.287 0 1 0-3.125 0v14.655H34.91zm22.29 13.728a3.139 3.139 0 1 1 3.162-3.139 3.154 3.154 0 0 1-3.162 3.139zm-27.339 27.926v-7.217h54.672v7.217z",
    fill: "#272a37",
    transform: "translate(-18.967 -53.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33531",
    d: "M247.563 5.85a1.563 1.563 0 0 0 1.563-1.562V1.563a1.563 1.563 0 0 0-3.125 0v2.724a1.563 1.563 0 0 0 1.562 1.563z",
    fill: "#272a37",
    transform: "translate(-209.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33532",
    d: "M467.453 233.507h-2.738a1.563 1.563 0 0 0 0 3.125h2.738a1.563 1.563 0 0 0 0-3.125z",
    fill: "#272a37",
    transform: "translate(-392.554 -197.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33533",
    d: "M15.625 236.632a1.563 1.563 0 0 0 0-3.125h-2.739a1.563 1.563 0 1 0 0 3.125z",
    fill: "#272a37",
    transform: "translate(-11.324 -197.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33534",
    d: "M401.111 73.444a1.558 1.558 0 0 0 1.1-.455l1.936-1.927a1.563 1.563 0 0 0-2.2-2.215l-1.936 1.927a1.563 1.563 0 0 0 1.1 2.67z",
    fill: "#272a37",
    transform: "translate(-338.888 -57.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33535",
    d: "M82.455 72.99a1.563 1.563 0 0 0 2.2-2.215l-1.936-1.927a1.563 1.563 0 0 0-2.2 2.215z",
    fill: "#272a37",
    transform: "translate(-69.319 -57.706)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.f851ff8ebb27ea23709b2b7f75b28c30.svg";
export { ForwardRef as ReactComponent };